<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Work Session Type"
      text="Edit Work Session Type"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="10">
              <v-text-field
                v-model="localWorkSessionType.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Name"
              />
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="localWorkSessionType.is_active"
              >
                <template v-slot:label>
                  <div>
                    Active?
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-container> 
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      workSessionType: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localWorkSessionType: null,
        rules: [
          value => !!value || 'Required.',
        ],
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        this.localWorkSessionType = { ...this.workSessionType }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.$api.workSessionTypes().update(this.localWorkSessionType.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: 'Work Session Type updated succesfully' })
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
                this.dialog = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localWorkSessionType.name,
          is_active: this.localWorkSessionType.is_active,
        }
      },
    },
  }
</script>
